<script setup lang="ts">
import type { SelectMenuItem } from "@nuxt/ui";

import {
	computed, ref, watch, 
} from "vue";

import justShuffle from "just-shuffle";

import { useBrokerageList } from "@/queries/brokerages";

const modelValue = defineModel<string | null>();


const { data: brokerages } = useBrokerageList();
const selectedBrokerage = ref<{
	label: string;
	value: string;
	avatar: { src: string; alt: string | undefined; } | undefined;
	icon: string | undefined;
} | null>(null);

watch(selectedBrokerage, () => {
	if (selectedBrokerage.value?.value !== "other") {
		modelValue.value = selectedBrokerage.value?.value ?? null;
	}
});

watch(modelValue, () => {
	if (!modelValue.value) {
		selectedBrokerage.value = null;
		otherBrokerage.value = null;
	}
});

const otherBrokerage = ref<string | null>(null);

watch(otherBrokerage, () => {
	if (otherBrokerage.value) {
		modelValue.value = otherBrokerage.value;
	}
});

const brokerList = computed(() => {
	const list = justShuffle(brokerages.value ?? []);
	const items = list.map((brokerage) => ({
		label: brokerage.name,
		value: brokerage.name,
		avatar: {
			src: brokerage.avatar ?? undefined,
			alt: brokerage.name,
		},
	}) satisfies SelectMenuItem);

	return [
		{
			type: "brokerages",
			label: "Brokerages",
		},
		...items,
		{
			type: "separator",
		},
		{
			type: "other",
			label: "More options...",
		},
		{
			
			label: "My broker is not listed",
			value: "other",
			icon: "ic-round-person-add",
		},
		{
			label: "Help me find a broker",
			value: "help",
			icon: "ic-round-handshake",
		},
	] as SelectMenuItem[];
});

</script>

<template>
  <div class="flex flex-col gap-2">
    <USelectMenu
      :key="selectedBrokerage?.value"
      v-model="selectedBrokerage"
      :avatar="selectedBrokerage?.avatar"
      :icon="selectedBrokerage?.icon"
      :items="brokerList"
      label="Brokerage"
      placeholder="Select a brokerage"
      class="w-full"
    />
    <UFormField
      v-if="selectedBrokerage?.value === 'other'"
      class="w-full"
    >
      <UInput
        v-model="otherBrokerage"
        placeholder="Enter the name of your brokerage"
        class="w-full"
      />
    </UFormField>
  </div>
</template>